<template>
    <v-app v-if="loggedInUser" :class="isLiveServer() && loggedInUser.is_developer ? 'theme--error' : ''">
        <DefaultLayout>
            <router-view :key="this.$route.params.id"/>
        </DefaultLayout>
        <v-snackbar v-if="needsSWRefresh" :timeout="-1" top :value="true" app rounded width="600">
            <strong>Er is een verbeterde versie van BOSS beschikbaar</strong><br/>
            Zorg dat al je werk is opgeslagen en klik op bijwerken om verder te gaan.

            <template v-slot:action>
                <v-btn color="success" :disabled="isSWRefreshing" @click="updateServiceWorker">
                    <v-icon left>mdi-check</v-icon>
                    Bijwerken
                </v-btn>
            </template>
        </v-snackbar>

        <atlas-migration-dialog />
    </v-app>
</template>

<script>
import User from "@/models/User/User";
import Vue from "vue";
import DefaultLayout from "@/components/Layout/DefaultLayout";
import AtlasMigrationDialog from "@/components/General/Dialog/AtlasMigrationDialog";
import EnvironmentService from "@/utils/Services/EnvironmentService";
import UseRegisterSW from '@/mixins/UseRegisterSW'
import * as Sentry from "@sentry/vue";

export default {
    name: 'App',
    mixins: [UseRegisterSW],
    components: {DefaultLayout, AtlasMigrationDialog},
    data() {
        return {
            loggedInUser: null,
        }
    },
    methods: {
        isLiveServer() {
            return EnvironmentService.isLiveServer();
        },
        userSocketJoin(userId) {
            if (!this.$socket) return;

            const join = () => this.$socket.emit('user:join', userId);
            this.$socket.on('connect', join);
            if (this.$socket.connected) {
                join();
                return;
            }
            this.$socket.connect();
        },
    },
    created() {
        User.api().limit(0).get(true).then(() => {
            User.api().action('current').getSingle().then(me => {
                Vue.prototype.$loggedInUserId = me.id;
                this.loggedInUser = User.loggedInUser();
                Sentry.setUser({
                    id: me.id,
                    email: me.email,
                    username: me.name,
                });

                this.userSocketJoin(this.loggedInUser.id);
            });
        });
    },
};
</script>

<style>
@font-face {
    font-family: Brandon Grotesque;
    src: url("/fonts/brandon-grotesque/brandon-grotesque.woff2") format("woff2");
    font-weight: normal;
    font-style: normal;
    font-display: block;
}

@font-face {
    font-family: Source Sans Pro Regular;
    src: url("/fonts/source-sans-pro/sourcesanspro-regular.woff2") format("woff2");
    font-weight: normal;
    font-style: normal;
    font-display: block;
}

@font-face {
    font-family: Source Sans Pro Light;
    src: url("/fonts/source-sans-pro/sourcesanspro-light.woff2") format("woff2");
    font-weight: 300;
    font-style: normal;
    font-display: block;
}

@font-face {
    font-family: Luxia Regular;
    src: url("/fonts/luxia/Luxia-Regular.otf") format("opentype");
    font-weight: normal;
    font-style: normal;
    font-display: block;
}

@font-face {
    font-family: Luxia Display;
    src: url("/fonts/luxia/Luxia-Display.otf") format("opentype");
    font-weight: normal;
    font-style: normal;
    font-display: block;
}
</style>
